import {DocumentFormBuilderComponent} from "../document-form-builder.component";
import {OnInit} from "@angular/core";
import {Claim} from "../../../model/claim.model";
import {DocumentField} from "../../../model/document-field";
import {SmartqDocuments} from "../../../model/smartq-documents.model";
import {ClaimTypes} from "../../../model/claim-type.model";
import { HomeFormBuilderUtil } from "./home-form-builder-util";

export class BurglaryFormBuilder extends DocumentFormBuilderComponent implements OnInit {
   
    constructor(claim: Claim){
        super(claim);
       this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_HOME_BURGLARY];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];

        requiredDocuments.push(new DocumentField('BURGREPREPINVOICES', 'homeProduct.supportingDocs.types.repairReplacementInvoices', SmartqDocuments.HOME_INVOICE, true));
        requiredDocuments.push(new DocumentField('BURGREPRECEIPT', 'homeProduct.supportingDocs.types.possibleRepairReceipt', SmartqDocuments.HOME_REPRECEIPT, true));
        requiredDocuments.push(new DocumentField('BURGPURCHRECEIPT', 'homeProduct.supportingDocs.types.purchaseReceiptLoss', SmartqDocuments.HOME_REPINVOICE, true));
        requiredDocuments.push(new DocumentField('BURGPHOTOS', 'homeProduct.supportingDocs.types.photoDamagePropertyScene', SmartqDocuments.HOME_PHOTOS, true));
        requiredDocuments.push(new DocumentField('BURGAUTHREPORT', 'homeProduct.supportingDocs.types.lossDamageReportAuthorities', SmartqDocuments.HOME_INVESTIGATION, true));
        requiredDocuments.push(new DocumentField('BURGBLDGREPORT', 'homeProduct.supportingDocs.types.buildingReport', SmartqDocuments.HOME_REPORT, true));
        requiredDocuments.push(new DocumentField('BURGCONSENT', 'homeProduct.supportingDocs.types.consentLetter', SmartqDocuments.HOME_ENDORSEDOC, true));
        
        let utilities: HomeFormBuilderUtil = new HomeFormBuilderUtil();
        requiredDocuments = requiredDocuments.concat(utilities.getRiskDocuments(this.claim));
        
        this.requiredDocuments = requiredDocuments;
    }
}